const $b72e7fd16f25353a$export$176c9ac0984acede = {
    CANVAS_WIDTH: window.innerWidth * 9 / 10,
    CANVAS_HEIGHT: window.innerHeight * 3 / 4,
    PARALLAX: {
        WIDTH: 2000,
        HEIGHT: 1176,
        LAYER_1_SPEED_MODIFIER: 0.7,
        LAYER_2_SPEED_MODIFIER: 0.5,
        LAYER_3_SPEED_MODIFIER: 0.4,
        LAYER_4_SPEED_MODIFIER: 0.2
    },
    GAME_SPEED: 5,
    ENEMY_GENERATION_INTERVAL_MS: 1000,
    PICKUP_GENERATION_INTERVAL_MS: 10000,
    FPS: 15,
    FRAME_TIMER: 0,
    FRAME_INTERVAL: function() {
        return 1000 / this.FPS;
    },
    WEAPON_RANGE_BUFFER: 0.8,
    TOTAL_AMMO: 50,
    AMMO_INTERVAL_MS: 500,
    UI: {
        FONT_SIZE: "20px",
        FONT_FAMILY: "Silkscreen",
        COLOR: "grey"
    }
};
const $b72e7fd16f25353a$export$e579c826c46257da = {
    SCORE: {
        X: 10,
        Y: 30
    },
    ImageUI: {
        X: $b72e7fd16f25353a$export$176c9ac0984acede.CANVAS_WIDTH - 100,
        Y: 30,
        SPRITE_WIDTH: 32,
        SPRITE_HEIGHT: 32
    },
    BulletUI: {
        IMG_SRC: "./assets/UI/bullet.png",
        SPRITE_WIDTH: 32,
        SPRITE_HEIGHT: 32,
        X: 10,
        Y: 60,
        TEXT_X: 40,
        TEXT_Y: 60
    },
    GameOver: {
        X: $b72e7fd16f25353a$export$176c9ac0984acede.CANVAS_WIDTH / 2 - 200,
        Y: $b72e7fd16f25353a$export$176c9ac0984acede.CANVAS_HEIGHT / 2,
        FONT_SIZE: "50px",
        FONT_FAMILY: "Silkscreen",
        COLOR: "grey"
    }
};
const $b72e7fd16f25353a$export$b91951f5210cfe92 = {
    UP: "ArrowUp",
    DOWN: "ArrowDown",
    ATTACK: "ArrowRight"
};



const $c57d13da953be0a9$export$c4511241a90a387b = {
    FullHealth: {
        IMG_SRC: "./assets/player/player-full-health.png",
        HighHealth: 100,
        LowHealth: 75
    },
    SlightDamage: {
        IMG_SRC: "./assets/player/player-slight-damage.png",
        HighHealth: 75,
        LowHealth: 50
    },
    MidDamage: {
        IMG_SRC: "./assets/player/player-damaged.png",
        HighHealth: 50,
        LowHealth: 25
    },
    HighDamage: {
        IMG_SRC: "./assets/player/player-very-damaged.png",
        HighHealth: 25,
        LowHealth: 0
    },
    SPRITE_WIDTH: 100,
    SPRITE_HEIGHT: 64,
    INITIAL_HEALTH: 100,
    INITIAL_X_POS_PX: 80,
    INITIAL_Y_POS_PX: (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_HEIGHT / 2,
    SPEED: 5,
    MAX_SPEED: 10,
    UP_DIRECTION: -1,
    DOWN_DIRECTION: 1,
    TOTAL_AMMO: 30
};
const $c57d13da953be0a9$export$e03a33cfa2382a10 = {
    SHIELD: {
        IMG_SRC: "./assets/player/shields/round-shield.png",
        MAX_FRAME: 11,
        SPRITE_WIDTH: 128,
        SPRITE_HEIGHT: 100,
        X_POS_BUFFER_PX: 24,
        Y_POS_BUFFER_PX: 20
    },
    TURRET: {
        IMG_SRC: "./assets/player/pickups/SpaceGun.png",
        MAX_FRAME: 6,
        SPRITE_WIDTH: 100,
        SPRITE_HEIGHT: 64,
        X_POS_BUFFER_PX: -12,
        Y_POS_BUFFER_PX: 0
    }
};
const $c57d13da953be0a9$export$1962987d6882b7fa = {
    FLY: 0,
    ATTACK: 1,
    SHIELD: 2
};
const $c57d13da953be0a9$export$34e4932e94563b26 = {
    INITIAL_X_POS_PX: $c57d13da953be0a9$export$c4511241a90a387b.INITIAL_X_POS_PX + $c57d13da953be0a9$export$c4511241a90a387b.SPRITE_WIDTH / 2,
    CannonBullet: {
        IMG_SRC: "./assets/player/weapons/cannon-bullet.png",
        SPRITE_WIDTH: 32,
        SPRITE_HEIGHT: 32,
        DAMAGE: 2,
        SPEED: 10,
        MAX_FRAME: 3
    }
};
const $c57d13da953be0a9$export$d5c8f8fde30f6806 = {
    SPRITE_WIDTH: 96,
    SPRITE_HEIGHT: 96,
    BASE: {
        IMG_SRC: "./assets/player/engine-bursts/base-engine-burst.png",
        BURST_SPEED: 5,
        MAX_FRAME: 2
    }
};




class $adc50ff192675bf9$export$2e2bcd8739ae039 {
    constructor(stateName){
        this.stateName = stateName;
    }
}


class $5b99b2606e77461e$export$2e2bcd8739ae039 extends (0, $adc50ff192675bf9$export$2e2bcd8739ae039) {
    constructor(game){
        super((0, $c57d13da953be0a9$export$1962987d6882b7fa).FLY);
        this.game = game;
    }
    enter() {}
    handleInput(input) {
        if (input.has((0, $b72e7fd16f25353a$export$b91951f5210cfe92).UP)) this.game.player.y += (0, $c57d13da953be0a9$export$c4511241a90a387b).UP_DIRECTION * (0, $c57d13da953be0a9$export$c4511241a90a387b).SPEED;
        if (input.has((0, $b72e7fd16f25353a$export$b91951f5210cfe92).DOWN)) this.game.player.y += (0, $c57d13da953be0a9$export$c4511241a90a387b).DOWN_DIRECTION * (0, $c57d13da953be0a9$export$c4511241a90a387b).SPEED;
        if (input.has((0, $b72e7fd16f25353a$export$b91951f5210cfe92).ATTACK)) this.game.player.setState((0, $c57d13da953be0a9$export$1962987d6882b7fa).ATTACK);
    }
}








class $8e73dec4e99ae5d8$export$2e2bcd8739ae039 {
    constructor(){
        this.x = (0, $c57d13da953be0a9$export$34e4932e94563b26).INITIAL_X_POS_PX;
        this.image = new Image();
        this.markedForDeletion = false;
        this.frameX = 0;
        this.maxFrame = (0, $c57d13da953be0a9$export$34e4932e94563b26).CannonBullet.MAX_FRAME;
        this.fps = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FPS;
        this.frameTimer = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_TIMER;
        this.frameInterval = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_INTERVAL;
    }
    draw(context, deltaTime) {
        if (this.frameTimer > this.frameInterval) {
            if (this.frameX < this.maxFrame) this.frameX++;
            else this.frameX = 0;
            this.frameTimer = 0;
        } else if (typeof deltaTime == "number") this.frameTimer = Number(this.frameTimer) + Number(deltaTime);
        context.drawImage(this.image, this.frameX * this.spriteWidth, 0, this.spriteWidth, this.spriteHeight, this.x, this.y, this.spriteWidth, this.spriteHeight);
    }
    update() {
        this.x += this.speed;
        if (this.x > (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_WIDTH * (0, $b72e7fd16f25353a$export$176c9ac0984acede).WEAPON_RANGE_BUFFER) this.markedForDeletion = true;
    }
}


class $d102810bdeacb50f$export$2e2bcd8739ae039 extends (0, $8e73dec4e99ae5d8$export$2e2bcd8739ae039) {
    constructor(game){
        super();
        this.game = game;
        this.y = this.game.player.y + this.game.player.spriteHeight / 2;
        this.image.src = (0, $c57d13da953be0a9$export$34e4932e94563b26).CannonBullet.IMG_SRC;
        this.spriteWidth = (0, $c57d13da953be0a9$export$34e4932e94563b26).CannonBullet.SPRITE_WIDTH;
        this.spriteHeight = (0, $c57d13da953be0a9$export$34e4932e94563b26).CannonBullet.SPRITE_HEIGHT;
        this.speed = (0, $c57d13da953be0a9$export$34e4932e94563b26).CannonBullet.SPEED;
        this.damage = (0, $c57d13da953be0a9$export$34e4932e94563b26).CannonBullet.DAMAGE;
    }
}




class $ef93014de0521373$export$2e2bcd8739ae039 {
    constructor(){
        this.image = new Image();
        this.image.src = (0, $c57d13da953be0a9$export$e03a33cfa2382a10).SHIELD.IMG_SRC;
        this.x = 0;
        this.y = 0;
        this.spriteWidth = (0, $c57d13da953be0a9$export$e03a33cfa2382a10).SHIELD.SPRITE_WIDTH;
        this.spriteHeight = (0, $c57d13da953be0a9$export$e03a33cfa2382a10).SHIELD.SPRITE_HEIGHT;
        this.frameX = 0;
        this.maxFrame = (0, $c57d13da953be0a9$export$e03a33cfa2382a10).SHIELD.MAX_FRAME;
        this.fps = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FPS;
        this.frameTimer = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_TIMER;
        this.frameInterval = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_INTERVAL();
    }
    draw(context, deltaTime) {
        if (this.frameTimer > this.frameInterval) {
            if (this.frameX < this.maxFrame) this.frameX++;
            else this.frameX = 0;
            this.frameTimer = 0;
        } else if (typeof deltaTime == "number") this.frameTimer = Number(this.frameTimer) + Number(deltaTime);
        context.drawImage(this.image, this.frameX * this.spriteWidth, 0, this.spriteWidth, this.spriteHeight, this.x, this.y, this.spriteWidth, this.spriteHeight);
    }
    update(playerX, playerY) {
        this.x = playerX - (0, $c57d13da953be0a9$export$e03a33cfa2382a10).SHIELD.X_POS_BUFFER_PX;
        this.y = playerY - (0, $c57d13da953be0a9$export$e03a33cfa2382a10).SHIELD.Y_POS_BUFFER_PX;
    }
}




class $b639e5c31eb95daf$export$2e2bcd8739ae039 {
    constructor(){
        this.image = new Image();
        this.image.src = (0, $c57d13da953be0a9$export$e03a33cfa2382a10).TURRET.IMG_SRC;
        this.x = 0;
        this.y = 0;
        this.spriteWidth = (0, $c57d13da953be0a9$export$e03a33cfa2382a10).TURRET.SPRITE_WIDTH;
        this.spriteHeight = (0, $c57d13da953be0a9$export$e03a33cfa2382a10).TURRET.SPRITE_HEIGHT;
        this.frameX = 0;
        this.maxFrame = (0, $c57d13da953be0a9$export$e03a33cfa2382a10).TURRET.MAX_FRAME;
        this.fps = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FPS;
        this.frameTimer = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_TIMER;
        this.frameInterval = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_INTERVAL();
    }
    draw(context, deltaTime) {
        if (this.frameTimer > this.frameInterval) {
            if (this.frameX < this.maxFrame) this.frameX++;
            else this.frameX = 0;
            this.frameTimer = 0;
        } else if (typeof deltaTime == "number") this.frameTimer = Number(this.frameTimer) + Number(deltaTime);
        context.drawImage(this.image, this.frameX * this.spriteWidth, 0, this.spriteWidth, this.spriteHeight, this.x, this.y, this.spriteWidth, this.spriteHeight);
    }
    update(playerX, playerY) {
        this.x = playerX - (0, $c57d13da953be0a9$export$e03a33cfa2382a10).TURRET.X_POS_BUFFER_PX;
        this.y = playerY - (0, $c57d13da953be0a9$export$e03a33cfa2382a10).TURRET.Y_POS_BUFFER_PX;
    }
}



const $3f89f06c5fe3cf70$export$c8aac97326029c44 = {
    SHIELD: new (0, $ef93014de0521373$export$2e2bcd8739ae039)(),
    TURRET: new (0, $b639e5c31eb95daf$export$2e2bcd8739ae039)()
};
const $3f89f06c5fe3cf70$export$86092f9fab975ff = {
    SPEED: -10,
    INITIAL_X_POS_PX: (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_WIDTH + 100,
    Shield: {
        IMG_SRC: "./assets/player/pickups/round-shield.png",
        SPRITE_WIDTH: 32,
        SPRITE_HEIGHT: 32,
        TOTAL_TIME_MS: 25000
    },
    Turret: {
        IMG_SRC: "./assets/player/pickups/SpaceGun-UI.png",
        SPRITE_WIDTH: 32,
        SPRITE_HEIGHT: 32,
        TOTAL_TIME_MS: 10000
    }
};


class $d8c8c1d2682620f1$export$2e2bcd8739ae039 extends (0, $adc50ff192675bf9$export$2e2bcd8739ae039) {
    constructor(game){
        super((0, $c57d13da953be0a9$export$1962987d6882b7fa).ATTACK);
        this.game = game;
    }
    enter() {}
    handleInput(input) {
        if (input.has((0, $b72e7fd16f25353a$export$b91951f5210cfe92).ATTACK) && this.game.currentAmmo > 0) {
            this.game.playerWeaponProjectiles.push(new (0, $d102810bdeacb50f$export$2e2bcd8739ae039)(this.game));
            // if turret is not active then decrease ammo else unlimited ammo
            if (!this.game.player.ability.has((0, $3f89f06c5fe3cf70$export$c8aac97326029c44).TURRET)) this.game.currentAmmo -= 1;
        }
        if (input.has((0, $b72e7fd16f25353a$export$b91951f5210cfe92).UP) || input.has((0, $b72e7fd16f25353a$export$b91951f5210cfe92).DOWN)) this.game.player.setState((0, $c57d13da953be0a9$export$1962987d6882b7fa).FLY);
    }
}






class $f4df88c2de76915d$export$2e2bcd8739ae039 {
    constructor(){
        this.image = new Image();
        this.spriteWidth = (0, $c57d13da953be0a9$export$d5c8f8fde30f6806).SPRITE_WIDTH;
        this.spriteHeight = (0, $c57d13da953be0a9$export$d5c8f8fde30f6806).SPRITE_HEIGHT;
        this.frameX = 0;
        this.fps = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FPS;
        this.frameTimer = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_TIMER;
        this.frameInterval = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_INTERVAL();
    }
    draw(context, deltaTime) {
        if (this.frameTimer > this.frameInterval) {
            if (this.frameX < this.maxFrame) this.frameX++;
            else this.frameX = 0;
            this.frameTimer = 0;
        } else if (typeof deltaTime == "number") this.frameTimer = Number(this.frameTimer) + Number(deltaTime);
        context.drawImage(this.image, this.frameX * this.spriteWidth, 0, this.spriteWidth, this.spriteHeight, this.x, this.y, this.spriteWidth, this.spriteHeight);
    }
    update(x, y) {
        this.x = x;
        this.y = y;
    }
}


class $f34bacb6614a13ea$export$2e2bcd8739ae039 extends (0, $f4df88c2de76915d$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.image.src = (0, $c57d13da953be0a9$export$d5c8f8fde30f6806).BASE.IMG_SRC;
        this.maxFrame = (0, $c57d13da953be0a9$export$d5c8f8fde30f6806).BASE.MAX_FRAME;
        this.burstSpeed = (0, $c57d13da953be0a9$export$d5c8f8fde30f6806).BASE.BURST_SPEED;
    }
}


class $067daba8e437eb27$export$2e2bcd8739ae039 {
    constructor(game){
        this.game = game;
        this.image = new Image();
        this.image.src = (0, $c57d13da953be0a9$export$c4511241a90a387b).FullHealth.IMG_SRC;
        this.spriteWidth = (0, $c57d13da953be0a9$export$c4511241a90a387b).SPRITE_WIDTH;
        this.spriteHeight = (0, $c57d13da953be0a9$export$c4511241a90a387b).SPRITE_HEIGHT;
        this.x = (0, $c57d13da953be0a9$export$c4511241a90a387b).INITIAL_X_POS_PX;
        this.y = (0, $c57d13da953be0a9$export$c4511241a90a387b).INITIAL_Y_POS_PX;
        this.health = (0, $c57d13da953be0a9$export$c4511241a90a387b).INITIAL_HEALTH;
        this.states = [
            new (0, $5b99b2606e77461e$export$2e2bcd8739ae039)(this.game),
            new (0, $d8c8c1d2682620f1$export$2e2bcd8739ae039)(this.game)
        ];
        this.currentState = this.states[(0, $c57d13da953be0a9$export$1962987d6882b7fa).FLY];
        this.fps = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FPS;
        this.frameTimer = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_TIMER;
        this.frameInterval = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_INTERVAL();
        this.burst = new (0, $f34bacb6614a13ea$export$2e2bcd8739ae039)();
        this.ability = new Set();
    }
    draw(context, deltaTime) {
        if (this.frameTimer > this.frameInterval) {
            if (this.frameX < this.maxFrame) this.frameX++;
            else this.frameX = 0;
            this.frameTimer = 0;
        } else if (typeof deltaTime == "number") this.frameTimer = Number(this.frameTimer) + Number(deltaTime);
        this.burst.draw(context, deltaTime);
        this.ability.forEach((ability)=>{
            ability.draw(context, deltaTime);
        });
        context.drawImage(this.image, this.x, this.y, this.spriteWidth, this.spriteHeight);
    }
    update(input) {
        if (this.health > (0, $c57d13da953be0a9$export$c4511241a90a387b).FullHealth.LowHealth) this.image.src = (0, $c57d13da953be0a9$export$c4511241a90a387b).FullHealth.IMG_SRC;
        else if (this.health <= (0, $c57d13da953be0a9$export$c4511241a90a387b).SlightDamage.HighHealth && this.health > (0, $c57d13da953be0a9$export$c4511241a90a387b).SlightDamage.LowHealth) this.image.src = (0, $c57d13da953be0a9$export$c4511241a90a387b).SlightDamage.IMG_SRC;
        else if (this.health <= (0, $c57d13da953be0a9$export$c4511241a90a387b).MidDamage.HighHealth && this.health > (0, $c57d13da953be0a9$export$c4511241a90a387b).MidDamage.LowHealth) this.image.src = (0, $c57d13da953be0a9$export$c4511241a90a387b).MidDamage.IMG_SRC;
        else if (this.health <= (0, $c57d13da953be0a9$export$c4511241a90a387b).HighDamage.HighHealth) this.image.src = (0, $c57d13da953be0a9$export$c4511241a90a387b).HighDamage.IMG_SRC;
        this.currentState.handleInput(input);
        this.burst.update(this.x, this.y);
        // Boundaries
        if (this.y < 0) this.y = 0;
        if (this.y >= this.game.gameHeight - this.spriteHeight) this.y = this.game.gameHeight - this.spriteHeight;
        this.ability.forEach((ability)=>{
            ability.update(this.x, this.y);
        });
    }
    setState(state) {
        this.currentState = this.states[state];
        this.currentState.enter();
    }
}



class $fd7f235c52f96c41$export$2e2bcd8739ae039 {
    constructor(game){
        this.game = game;
        window.addEventListener("keydown", (e)=>{
            if (e.key == (0, $b72e7fd16f25353a$export$b91951f5210cfe92).UP || e.key == (0, $b72e7fd16f25353a$export$b91951f5210cfe92).DOWN || e.key == (0, $b72e7fd16f25353a$export$b91951f5210cfe92).ATTACK) this.game.keys.add(e.key);
        });
        window.addEventListener("keyup", (e)=>{
            if (this.game.keys.has(e.key)) this.game.keys.delete(e.key);
        });
    }
}




class $b4570cfcb170ce1f$export$2e2bcd8739ae039 {
    constructor(){
        this.image = new Image();
        this.markedForDeletion = false;
        this.frameX = 0;
        this.fps = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FPS;
        this.frameTimer = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_TIMER;
        this.frameInterval = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_INTERVAL;
    }
    draw(context, deltaTime) {
        if (this.frameTimer > this.frameInterval) {
            if (this.frameX < this.maxFrame) this.frameX++;
            else this.frameX = 0;
            this.frameTimer = 0;
        } else if (typeof deltaTime == "number") this.frameTimer = Number(this.frameTimer) + Number(deltaTime);
        context.drawImage(this.image, this.frameX * this.spriteWidth, 0, this.spriteWidth, this.spriteHeight, this.x, this.y, this.spriteWidth, this.spriteHeight);
    }
    update() {
        this.x += this.speed;
        if (this.x > (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_WIDTH || this.y > (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_HEIGHT) this.markedForDeletion = true;
    }
}


class $59c927d0bd8f4fca$export$2e2bcd8739ae039 extends (0, $b4570cfcb170ce1f$export$2e2bcd8739ae039) {
    constructor(x, y){
        super();
        this.spriteWidth = (0, $eacd6a50b8792740$export$dbdf6b2a5cc3d391).Bullet.SPRITE_WIDTH;
        this.spriteHeight = (0, $eacd6a50b8792740$export$dbdf6b2a5cc3d391).Bullet.SPRITE_HEIGHT;
        this.x = x;
        this.y = y;
        this.image.src = (0, $eacd6a50b8792740$export$dbdf6b2a5cc3d391).Bullet.IMG_SRC;
        this.maxFrame = (0, $eacd6a50b8792740$export$dbdf6b2a5cc3d391).Bullet.MAX_FRAME;
        this.speed = (0, $eacd6a50b8792740$export$dbdf6b2a5cc3d391).Bullet.SPEED;
        this.damage = (0, $eacd6a50b8792740$export$dbdf6b2a5cc3d391).Bullet.DAMAGE;
    }
}



const $eacd6a50b8792740$var$Weapons = {
    bullet: (0, $59c927d0bd8f4fca$export$2e2bcd8739ae039)
};
const $eacd6a50b8792740$export$dbdf6b2a5cc3d391 = {
    Bullet: {
        IMG_SRC: "./assets/enemy/weapons/bullet.png",
        SPRITE_WIDTH: 24,
        SPRITE_HEIGHT: 18,
        MAX_FRAME: 7,
        SPEED: -10,
        DAMAGE: 10
    }
};
const $eacd6a50b8792740$export$6f98e456412ea8f1 = {
    SPAWN_BUFFER_DISTANCE_PX: 100,
    ShipFighter: {
        IMG_SRC_FLY: "./assets/enemy/ship-fighter/ship-fighter.png",
        IMG_SRC_DEATH: "./assets/enemy/ship-fighter/ship-fighter-death.png",
        SPRITE_WIDTH: 128,
        SPRITE_HEIGHT: 64,
        HEALTH: 10,
        MIN_SPEED: -5,
        MAX_SPEED: -5,
        ENEMY_SCORE: 5,
        ENEMY_DAMAGE: 10,
        MIN_Y_POS: 10,
        MAX_Y_POS: (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_HEIGHT / 2,
        MAX_FRAME_FLY: 0,
        MAX_FRAME_DEATH: 7,
        CAN_ATTACK: false,
        BURST: {
            IMG_SRC: "./assets/enemy/ship-fighter/ship-fighter-burst.png",
            SPRITE_WIDTH: 128,
            SPRITE_HEIGHT: 128,
            MAX_FRAME: 7
        },
        RARITY: 10
    },
    DreadNought: {
        IMG_SRC_FLY: "./assets/enemy/dreadnought/dreadnought.png",
        IMG_SRC_DEATH: "./assets/enemy/dreadnought/dreadnought-death.png",
        SPRITE_WIDTH: 256,
        SPRITE_HEIGHT: 144,
        HEALTH: 50,
        MIN_SPEED: -1,
        MAX_SPEED: -2,
        ENEMY_SCORE: 100,
        ENEMY_DAMAGE: 100,
        CAN_ATTACK: true,
        MIN_Y_POS: (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_HEIGHT / 2 - 100,
        MAX_Y_POS: (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_HEIGHT / 2 + 100,
        MAX_FRAME_FLY: 0,
        MAX_FRAME_DEATH: 11,
        ATTACK_TIMER: 0,
        ATTACK_INTERVAL_MIN: 2000,
        ATTACK_INTERVAL_MAX: 5000,
        BURST: {
            IMG_SRC: "./assets/enemy/dreadnought/dreadnought-burst.png",
            SPRITE_WIDTH: 256,
            SPRITE_HEIGHT: 256,
            MAX_FRAME: 7
        },
        WEAPONS: [
            $eacd6a50b8792740$var$Weapons.bullet
        ],
        RARITY: 1
    }
};
const $eacd6a50b8792740$export$101b638041da57ae = {
    FLY: 0,
    DEATH: 1,
    ATTACK: 2
};




class $e1a2a3a41fc47cd0$export$2e2bcd8739ae039 {
    constructor(){
        this.image = new Image();
        this.speed = (0, $3f89f06c5fe3cf70$export$86092f9fab975ff).SPEED;
        this.x = (0, $3f89f06c5fe3cf70$export$86092f9fab975ff).INITIAL_X_POS_PX;
        this.y = 200;
        this.markedForDeletion = false;
        this.pickedUpByPlayer = false;
        this.timer = 0;
    }
    draw(context) {
        context.drawImage(this.image, this.x, this.y);
    }
    update(deltaTime, player) {
        this.x += this.speed;
        if (this.x < -this.spriteWidth) this.markedForDeletion = true;
        if (player.ability.has((0, $3f89f06c5fe3cf70$export$c8aac97326029c44).SHIELD) || player.ability.has((0, $3f89f06c5fe3cf70$export$c8aac97326029c44).TURRET)) this.timer += deltaTime;
        if (this.timer > this.totalTime) {
            player.ability.delete(this.ability);
            this.markedForDeletion = true;
        }
    }
}


class $af6c686114cc0b55$export$2e2bcd8739ae039 extends (0, $e1a2a3a41fc47cd0$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.image.src = (0, $3f89f06c5fe3cf70$export$86092f9fab975ff).Turret.IMG_SRC;
        this.spriteWidth = (0, $3f89f06c5fe3cf70$export$86092f9fab975ff).Turret.SPRITE_WIDTH;
        this.spriteHeight = (0, $3f89f06c5fe3cf70$export$86092f9fab975ff).Turret.SPRITE_HEIGHT;
        this.totalTime = (0, $3f89f06c5fe3cf70$export$86092f9fab975ff).Turret.TOTAL_TIME_MS;
        this.ability = (0, $3f89f06c5fe3cf70$export$c8aac97326029c44).TURRET;
    }
    enter(player) {
        player.ability.add((0, $3f89f06c5fe3cf70$export$c8aac97326029c44).TURRET);
    }
}





class $f7b3d79480782dd5$export$2e2bcd8739ae039 {
    constructor(){
        this.image = new Image();
        this.image.src = "";
        this.x = (0, $b72e7fd16f25353a$export$e579c826c46257da).ImageUI.X;
        this.y = (0, $b72e7fd16f25353a$export$e579c826c46257da).ImageUI.Y;
        this.spriteWidth = (0, $b72e7fd16f25353a$export$e579c826c46257da).ImageUI.SPRITE_WIDTH;
        this.spriteHeight = (0, $b72e7fd16f25353a$export$e579c826c46257da).ImageUI.SPRITE_HEIGHT;
    }
    draw(context) {
        context.drawImage(this.image, this.x, this.y, this.spriteWidth, this.spriteHeight);
    }
    update(playerAbility) {
        this.image.src = "";
        if (playerAbility.has((0, $3f89f06c5fe3cf70$export$c8aac97326029c44).SHIELD)) this.image.src = (0, $3f89f06c5fe3cf70$export$86092f9fab975ff).Shield.IMG_SRC;
        // add other pickup abilities
        if (playerAbility.has((0, $3f89f06c5fe3cf70$export$c8aac97326029c44).TURRET)) this.image.src = (0, $3f89f06c5fe3cf70$export$86092f9fab975ff).Turret.IMG_SRC;
    }
}



class $ca5f36172bf71fe1$export$2e2bcd8739ae039 {
    constructor(){
        this.fontsize = (0, $b72e7fd16f25353a$export$176c9ac0984acede).UI.FONT_SIZE;
        this.fontFamily = (0, $b72e7fd16f25353a$export$176c9ac0984acede).UI.FONT_FAMILY;
        this.color = (0, $b72e7fd16f25353a$export$176c9ac0984acede).UI.COLOR;
        this.score = 0;
    }
    draw(context) {
        context.fillStyle = this.color;
        context.font = `${this.fontsize} ${this.fontFamily}`;
        context.fillText(`Score: ${this.score}`, (0, $b72e7fd16f25353a$export$e579c826c46257da).SCORE.X, (0, $b72e7fd16f25353a$export$e579c826c46257da).SCORE.Y);
    }
    update(score) {
        this.score = score;
    }
}



class $70c0f10b250b76f7$export$2e2bcd8739ae039 {
    constructor(){
        this.image = new Image();
        this.image.src = (0, $b72e7fd16f25353a$export$e579c826c46257da).BulletUI.IMG_SRC;
        this.spriteWidth = (0, $b72e7fd16f25353a$export$e579c826c46257da).BulletUI.SPRITE_WIDTH;
        this.spriteHeight = (0, $b72e7fd16f25353a$export$e579c826c46257da).BulletUI.SPRITE_HEIGHT;
        this.x = (0, $b72e7fd16f25353a$export$e579c826c46257da).BulletUI.X;
        this.y = (0, $b72e7fd16f25353a$export$e579c826c46257da).BulletUI.Y;
        this.textX = (0, $b72e7fd16f25353a$export$e579c826c46257da).BulletUI.TEXT_X;
        this.textY = (0, $b72e7fd16f25353a$export$e579c826c46257da).BulletUI.TEXT_Y;
        this.bulletCount = 0;
    }
    draw(context) {
        context.drawImage(this.image, 0, 0, this.spriteWidth, this.spriteHeight, this.x, this.y, this.spriteWidth, this.spriteHeight);
        context.fillStyle = "#ffc40c";
        context.fillRect(this.textX, this.textY + this.spriteHeight * 1 / 5, this.bulletCount, 20);
    }
    update(bullets) {
        this.bulletCount = bullets;
    }
}


function $f7b1c61d75fa3a2d$export$2e2bcd8739ae039(score) {
    const gameOverUI = document.getElementById("gameOver");
    gameOverUI.hidden = false;
    const restartBtn = document.getElementById("restart");
    restartBtn.hidden = false;
    gameOverUI.innerHTML = `Game Over! <br> Score: ${score}`;
}





class $b292be1f070b38c2$export$2e2bcd8739ae039 {
    constructor(image, speedModifier, gamespeed, canvasWidth, canvasHeight){
        this.x = 0;
        this.y = 0;
        this.imageWidth = 2000;
        this.imageHeight = 1176;
        this.canvasWidth = canvasWidth;
        this.canvasHeight = canvasHeight;
        this.image = image;
        this.gamespeed = gamespeed;
        this.speedModifier = speedModifier;
        this.speed = gamespeed * this.speedModifier + 5;
    }
    update(gamespeed) {
        this.speed = gamespeed * this.speedModifier;
        if (this.x <= -this.imageWidth) this.x = this.imageWidth + this.x - this.speed;
        this.x = Math.floor(this.x - this.speed);
    }
    draw(ctx) {
        ctx.drawImage(this.image, this.x, this.y, this.imageWidth, this.canvasHeight);
        ctx.drawImage(this.image, this.x + this.imageWidth, this.y, this.imageWidth, this.canvasHeight);
    }
}
function $b292be1f070b38c2$export$6c6441dd6d5ca8b1() {
    const Layer1 = new Image();
    Layer1.src = "./assets/Parallax/Layer-1.png";
    const Layer2 = new Image();
    Layer2.src = "./assets/Parallax/Layer-2.png";
    const Layer3 = new Image();
    Layer3.src = "./assets/Parallax/Layer-3.png";
    const Layer4 = new Image();
    Layer4.src = "./assets/Parallax/Layer-4.png";
    const ParallaxLayer1 = new $b292be1f070b38c2$export$2e2bcd8739ae039(Layer1, (0, $b72e7fd16f25353a$export$176c9ac0984acede).PARALLAX.LAYER_1_SPEED_MODIFIER, (0, $b72e7fd16f25353a$export$176c9ac0984acede).GAME_SPEED, (0, $b72e7fd16f25353a$export$176c9ac0984acede).PARALLAX.WIDTH, (0, $b72e7fd16f25353a$export$176c9ac0984acede).PARALLAX.HEIGHT);
    const ParallaxLayer2 = new $b292be1f070b38c2$export$2e2bcd8739ae039(Layer2, (0, $b72e7fd16f25353a$export$176c9ac0984acede).PARALLAX.LAYER_2_SPEED_MODIFIER, (0, $b72e7fd16f25353a$export$176c9ac0984acede).GAME_SPEED, (0, $b72e7fd16f25353a$export$176c9ac0984acede).PARALLAX.WIDTH, (0, $b72e7fd16f25353a$export$176c9ac0984acede).PARALLAX.HEIGHT);
    const ParallaxLayer3 = new $b292be1f070b38c2$export$2e2bcd8739ae039(Layer3, (0, $b72e7fd16f25353a$export$176c9ac0984acede).PARALLAX.LAYER_3_SPEED_MODIFIER, (0, $b72e7fd16f25353a$export$176c9ac0984acede).GAME_SPEED, (0, $b72e7fd16f25353a$export$176c9ac0984acede).PARALLAX.WIDTH, (0, $b72e7fd16f25353a$export$176c9ac0984acede).PARALLAX.HEIGHT);
    const ParallaxLayer4 = new $b292be1f070b38c2$export$2e2bcd8739ae039(Layer4, (0, $b72e7fd16f25353a$export$176c9ac0984acede).PARALLAX.LAYER_4_SPEED_MODIFIER, (0, $b72e7fd16f25353a$export$176c9ac0984acede).GAME_SPEED, (0, $b72e7fd16f25353a$export$176c9ac0984acede).PARALLAX.WIDTH, (0, $b72e7fd16f25353a$export$176c9ac0984acede).PARALLAX.HEIGHT);
    // const ParallaxLayer5 = new ParallaxLayer(Layer5, 0.4, gamespeed, 2000, 1176);
    return [
        // ParallaxLayer5,
        ParallaxLayer4,
        ParallaxLayer3,
        ParallaxLayer2,
        ParallaxLayer1
    ];
}






class $e211a1fff8df7abc$export$2e2bcd8739ae039 extends (0, $f4df88c2de76915d$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.spriteWidth = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.BURST.SPRITE_WIDTH;
        this.spriteHeight = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.BURST.SPRITE_HEIGHT;
        this.image.src = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.BURST.IMG_SRC;
        this.maxFrame = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.BURST.MAX_FRAME;
    }
}


class $3843f95dd0f581a7$export$2e2bcd8739ae039 {
    constructor(){
        this.image = new Image();
        this.x = (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_WIDTH + (0, $eacd6a50b8792740$export$6f98e456412ea8f1).SPAWN_BUFFER_DISTANCE_PX;
        this.markedForDeletion = false;
        this.frameX = 0;
        this.maxFrame = 0;
        // is being used for death animation as player continuously collieds with enemy while it is not moving from the death state while the death animation plays
        this.isColliding = true;
        this.projectiles = [];
        this.burst = new (0, $e211a1fff8df7abc$export$2e2bcd8739ae039)();
        this.fps = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FPS;
        this.frameTimer = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_TIMER;
        this.frameInterval = (0, $b72e7fd16f25353a$export$176c9ac0984acede).FRAME_INTERVAL();
    }
    draw(context, deltaTime) {
        if (this.frameTimer > this.frameInterval) {
            if (this.frameX < this.maxFrame) this.frameX++;
            else this.frameX = 0;
            this.frameTimer = 0;
        } else if (typeof deltaTime == "number") this.frameTimer = Number(this.frameTimer) + Number(deltaTime);
        this.projectiles.forEach((projectile)=>{
            projectile.draw(context, deltaTime);
        });
        this.burst.draw(context, deltaTime);
        context.drawImage(this.image, this.frameX * this.spriteWidth, 0, this.spriteWidth, this.spriteHeight, this.x, this.y, this.spriteWidth, this.spriteHeight);
    }
    update(deltaTime) {
        this.currentState.update(deltaTime);
        this.projectiles.forEach((projectile)=>{
            projectile.update();
        });
        this.burst.update(this.x, this.y);
    }
    setState(statename) {
        this.currentState = this.states[statename];
        this.currentState.enter();
    }
}
function $3843f95dd0f581a7$export$3c5f89dae98e900b(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}





class $193279e836d07d0e$export$2e2bcd8739ae039 extends (0, $adc50ff192675bf9$export$2e2bcd8739ae039) {
    constructor(enemy, img_src, maxFrame){
        super((0, $eacd6a50b8792740$export$101b638041da57ae).FLY);
        this.enemy = enemy;
        this.imgSrc = img_src;
        this.maxFrame = maxFrame;
    }
    enter() {
        this.enemy.image.src = this.imgSrc;
        this.enemy.maxFrame = this.maxFrame;
        this.enemy.frameX = 0;
    }
    update(deltaTime) {
        this.enemy.x += this.enemy.speed;
        if (this.enemy.x < -this.enemy.spriteWidth) this.enemy.markedForDeletion = true;
        if (this.enemy.canAttack) {
            this.enemy.attackTimer += deltaTime;
            if (this.enemy.attackTimer > this.enemy.attackInterval) {
                this.enemy.setState((0, $eacd6a50b8792740$export$101b638041da57ae).ATTACK);
                this.enemy.attackTimer = 0;
            }
        }
    }
}





class $0d4c067961b40cf2$export$2e2bcd8739ae039 extends (0, $adc50ff192675bf9$export$2e2bcd8739ae039) {
    constructor(enemy, img_src, maxFrame){
        super((0, $eacd6a50b8792740$export$101b638041da57ae).DEATH);
        this.enemy = enemy;
        this.imgSrc = img_src;
        this.maxFrame = maxFrame;
    }
    enter() {
        this.enemy.burst.image.src = "";
        this.enemy.image.src = this.imgSrc;
        this.enemy.maxFrame = this.maxFrame;
        this.enemy.frameX = 0;
        this.enemy.isColliding = false;
    }
    update() {
        if (this.enemy.frameX >= this.enemy.maxFrame) this.enemy.markedForDeletion = true;
    }
}






class $b87cc7c12b11218b$export$2e2bcd8739ae039 extends (0, $f4df88c2de76915d$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.spriteWidth = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.BURST.SPRITE_WIDTH;
        this.spriteHeight = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.BURST.SPRITE_HEIGHT;
        this.image.src = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.BURST.IMG_SRC;
        this.maxFrame = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.BURST.MAX_FRAME;
    }
}





class $e86abe539d08ecb1$export$2e2bcd8739ae039 extends (0, $adc50ff192675bf9$export$2e2bcd8739ae039) {
    constructor(enemy){
        super((0, $eacd6a50b8792740$export$101b638041da57ae).ATTACK);
        this.enemy = enemy;
    }
    enter() {
        const randomWeaponIndex = (0, $3843f95dd0f581a7$export$3c5f89dae98e900b)(0, this.enemy.weapons.length - 1);
        this.enemy.projectiles.push(new this.enemy.weapons[randomWeaponIndex](this.enemy.x + this.enemy.spriteWidth / 2, this.enemy.y + this.enemy.spriteHeight / 2));
    }
    update() {
        this.enemy.setState((0, $eacd6a50b8792740$export$101b638041da57ae).FLY);
    }
}


class $2dec7627437b1ca7$export$2e2bcd8739ae039 extends (0, $3843f95dd0f581a7$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.name = "DreadNought";
        this.states = [
            new (0, $193279e836d07d0e$export$2e2bcd8739ae039)(this, (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.IMG_SRC_FLY, (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.MAX_FRAME_FLY),
            new (0, $0d4c067961b40cf2$export$2e2bcd8739ae039)(this, (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.IMG_SRC_DEATH, (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.MAX_FRAME_DEATH),
            new (0, $e86abe539d08ecb1$export$2e2bcd8739ae039)(this)
        ];
        this.currentState = this.states[(0, $eacd6a50b8792740$export$101b638041da57ae).FLY];
        this.y = (0, $3843f95dd0f581a7$export$3c5f89dae98e900b)((0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.MIN_Y_POS, (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.MAX_Y_POS);
        this.image.src = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.IMG_SRC_FLY;
        this.spriteWidth = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.SPRITE_WIDTH;
        this.spriteHeight = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.SPRITE_HEIGHT;
        this.speed = (0, $3843f95dd0f581a7$export$3c5f89dae98e900b)((0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.MIN_SPEED, (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.MAX_SPEED);
        this.health = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.HEALTH;
        this.score = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.ENEMY_SCORE;
        this.damage = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.ENEMY_DAMAGE;
        this.burst = new (0, $b87cc7c12b11218b$export$2e2bcd8739ae039)();
        this.canAttack = true;
        this.attackTimer = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.ATTACK_TIMER;
        this.attackInterval = (0, $3843f95dd0f581a7$export$3c5f89dae98e900b)((0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.ATTACK_INTERVAL_MIN, (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.ATTACK_INTERVAL_MAX);
        this.weapons = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.WEAPONS;
        this.rarity = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).DreadNought.RARITY;
    }
}





class $e8a6f254365ea9a9$export$2e2bcd8739ae039 extends (0, $3843f95dd0f581a7$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.name = "ShipFighter";
        this.states = [
            new (0, $193279e836d07d0e$export$2e2bcd8739ae039)(this, (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.IMG_SRC_FLY, (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.MAX_FRAME_FLY),
            new (0, $0d4c067961b40cf2$export$2e2bcd8739ae039)(this, (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.IMG_SRC_DEATH, (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.MAX_FRAME_DEATH)
        ];
        this.currentState = this.states[(0, $eacd6a50b8792740$export$101b638041da57ae).FLY];
        this.y = (0, $3843f95dd0f581a7$export$3c5f89dae98e900b)((0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.MIN_Y_POS, (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.MAX_Y_POS);
        this.image.src = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.IMG_SRC_FLY;
        this.spriteWidth = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.SPRITE_WIDTH;
        this.spriteHeight = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.SPRITE_HEIGHT;
        this.speed = (0, $3843f95dd0f581a7$export$3c5f89dae98e900b)((0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.MIN_SPEED, (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.MAX_SPEED);
        this.health = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.HEALTH;
        this.score = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.ENEMY_SCORE;
        this.damage = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.ENEMY_DAMAGE;
        this.canAttack = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.CAN_ATTACK;
        this.rarity = (0, $eacd6a50b8792740$export$6f98e456412ea8f1).ShipFighter.RARITY;
    }
}





const $08d4bb555ce153c2$var$pickRandomEnemy = ()=>{
    const num = (0, $3843f95dd0f581a7$export$3c5f89dae98e900b)(0, 1);
    switch(num){
        case 0:
            return new (0, $e8a6f254365ea9a9$export$2e2bcd8739ae039)();
        case 1:
            return new (0, $2dec7627437b1ca7$export$2e2bcd8739ae039)();
        default:
            break;
    }
};
const $08d4bb555ce153c2$export$be9b8cc71a71c056 = (enemyList)=>{
    const randomEnemy = $08d4bb555ce153c2$var$pickRandomEnemy();
    const defaultEnemy = new (0, $e8a6f254365ea9a9$export$2e2bcd8739ae039)();
    let count = 0;
    for (const enemy of enemyList){
        if (enemy.name == randomEnemy.name) count++;
        if (count >= enemy.rarity) return;
    }
    if (count <= randomEnemy.rarity) enemyList.push(randomEnemy);
    else enemyList.push(defaultEnemy);
};





class $5f125dd68b712379$export$2e2bcd8739ae039 extends (0, $e1a2a3a41fc47cd0$export$2e2bcd8739ae039) {
    constructor(){
        super();
        this.image.src = (0, $3f89f06c5fe3cf70$export$86092f9fab975ff).Shield.IMG_SRC;
        this.spriteWidth = (0, $3f89f06c5fe3cf70$export$86092f9fab975ff).Shield.SPRITE_WIDTH;
        this.spriteHeight = (0, $3f89f06c5fe3cf70$export$86092f9fab975ff).Shield.SPRITE_HEIGHT;
        this.totalTime = (0, $3f89f06c5fe3cf70$export$86092f9fab975ff).Shield.TOTAL_TIME_MS;
        this.ability = (0, $3f89f06c5fe3cf70$export$c8aac97326029c44).SHIELD;
    }
    enter(player) {
        player.ability.add((0, $3f89f06c5fe3cf70$export$c8aac97326029c44).SHIELD);
    }
}



function $6de4f418c48a9c49$export$2e2bcd8739ae039() {
    const num = (0, $3843f95dd0f581a7$export$3c5f89dae98e900b)(0, 1);
    switch(num){
        case 0:
            return new (0, $5f125dd68b712379$export$2e2bcd8739ae039)();
        case 1:
            return new (0, $af6c686114cc0b55$export$2e2bcd8739ae039)();
        default:
            break;
    }
}


window.addEventListener("load", ()=>{
    const loading = document.getElementById("loading");
    loading.remove();
    const canvas = document.getElementById("game-canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_WIDTH;
    canvas.height = (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_HEIGHT;
    startGameUI();
    class Game {
        constructor(){
            this.gameWidth = (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_WIDTH;
            this.gameHeight = (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_HEIGHT;
            this.player = new (0, $067daba8e437eb27$export$2e2bcd8739ae039)(this);
            this.allParallaxLayers = (0, $b292be1f070b38c2$export$6c6441dd6d5ca8b1)((0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_WIDTH, (0, $b72e7fd16f25353a$export$176c9ac0984acede).CANVAS_HEIGHT, (0, $b72e7fd16f25353a$export$176c9ac0984acede).GAME_SPEED);
            this.keys = new Set();
            this.inputHandler = new (0, $fd7f235c52f96c41$export$2e2bcd8739ae039)(this);
            this.enemies = [];
            this.enemyGenerationTimer = 0;
            this.enemyGenerationInterval = (0, $b72e7fd16f25353a$export$176c9ac0984acede).ENEMY_GENERATION_INTERVAL_MS;
            this.playerWeaponProjectiles = [];
            this.pickups = [];
            this.pickupTimer = 0;
            this.pickupGenerationInterval = (0, $b72e7fd16f25353a$export$176c9ac0984acede).PICKUP_GENERATION_INTERVAL_MS;
            this.gameOver = false;
            this.score = 0;
            this.totalAmmo = (0, $b72e7fd16f25353a$export$176c9ac0984acede).TOTAL_AMMO;
            this.currentAmmo = this.totalAmmo;
            this.ammoTimer = 0;
            this.ammoInterval = (0, $b72e7fd16f25353a$export$176c9ac0984acede).AMMO_INTERVAL_MS;
            this.scoreUI = new (0, $ca5f36172bf71fe1$export$2e2bcd8739ae039)();
            this.pickUpUI = new (0, $f7b3d79480782dd5$export$2e2bcd8739ae039)();
            this.bulletUI = new (0, $70c0f10b250b76f7$export$2e2bcd8739ae039)();
        }
        draw(deltaTime) {
            ctx.clearRect(0, 0, this.gameWidth, this.gameHeight);
            this.enemyGenerationTimer += deltaTime;
            if (this.enemyGenerationTimer > this.enemyGenerationInterval) {
                (0, $08d4bb555ce153c2$export$be9b8cc71a71c056)(this.enemies);
                this.enemyGenerationTimer = 0;
            }
            this.pickupTimer += deltaTime;
            if (this.pickupTimer > this.pickupGenerationInterval) {
                this.pickupTimer = 0;
                this.pickups.push((0, $6de4f418c48a9c49$export$2e2bcd8739ae039)());
            }
            this.allParallaxLayers.forEach((layer)=>{
                layer.draw(ctx);
            });
            this.scoreUI.draw(ctx);
            this.pickUpUI.draw(ctx);
            this.bulletUI.draw(ctx);
            this.player.draw(ctx, deltaTime);
            this.pickups.forEach((pickup)=>{
                pickup.draw(ctx);
            });
            this.enemies.forEach((enemy)=>{
                enemy.draw(ctx, deltaTime);
            });
            this.playerWeaponProjectiles.forEach((projectile)=>{
                projectile.draw(ctx, deltaTime);
            });
        }
        update(deltaTime) {
            this.scoreUI.update(this.score);
            this.pickUpUI.update(this.player.ability);
            this.bulletUI.update(this.currentAmmo);
            this.allParallaxLayers.forEach((layer)=>{
                layer.update((0, $b72e7fd16f25353a$export$176c9ac0984acede).GAME_SPEED);
            });
            if (this.ammoTimer > this.ammoInterval) {
                if (this.currentAmmo < this.totalAmmo) this.currentAmmo += 1;
                this.ammoTimer = 0;
            } else this.ammoTimer += deltaTime;
            this.player.update(this.keys);
            this.pickups.forEach((pickup, index)=>{
                pickup.update(deltaTime, this.player);
                if (this.checkCollision(pickup, this.player)) {
                    this.player.ability.add(pickup.ability);
                    pickup.markedForDeletion = true;
                // this.player.pickUpAddOns.add(
                //   new ShieldAddOn(PlayerPickupConfig.SHIELD.IMG_SRC),
                // );
                }
                if (pickup.markedForDeletion) {
                    this.pickups.slice(index, 1);
                    index--;
                }
            });
            this.enemies.forEach((enemy, index)=>{
                enemy.update(deltaTime);
                if (enemy.markedForDeletion) {
                    this.enemies.splice(index, 1);
                    index--;
                }
                if (enemy.isColliding && !this.player.ability.has((0, $3f89f06c5fe3cf70$export$c8aac97326029c44).SHIELD) && this.checkCollision(enemy, this.player)) {
                    enemy.setState((0, $eacd6a50b8792740$export$101b638041da57ae).DEATH);
                    this.player.health -= enemy.damage;
                    if (this.player.health <= 0) this.gameOver = true;
                }
                enemy.projectiles.forEach((projectile, ind)=>{
                    projectile.update();
                    if (!this.player.ability.has((0, $3f89f06c5fe3cf70$export$c8aac97326029c44).SHIELD) && this.checkCollision(projectile, this.player)) {
                        projectile.markedForDeletion = true;
                        this.player.health -= projectile.damage;
                    }
                    if (projectile.markedForDeletion) {
                        enemy.projectiles.splice(ind, 1);
                        ind--;
                    }
                });
                this.playerWeaponProjectiles.forEach((projectile, ind)=>{
                    projectile.update();
                    if (enemy.isColliding && this.checkCollision(enemy, projectile)) {
                        enemy.health -= projectile.damage;
                        projectile.markedForDeletion = true;
                        if (enemy.health <= 0) {
                            enemy.setState((0, $eacd6a50b8792740$export$101b638041da57ae).DEATH);
                            this.score += enemy.score;
                        }
                    }
                    if (projectile.markedForDeletion) {
                        this.playerWeaponProjectiles.splice(ind, 1);
                        ind--;
                    }
                });
            });
        }
        checkCollision(enemy, object) {
            // const dx = enemy.x - object.x;
            // const dy = enemy.y - object.y;
            // const distance = Math.sqrt(dx * dx + dy * dy);
            //
            // return distance < enemy.spriteWidth - object.spriteWidth;
            // rectangular object collision
            return enemy.x < object.x + object.spriteHeight && enemy.x + enemy.spriteHeight > object.x && enemy.y < object.y + object.spriteHeight && enemy.y + enemy.spriteHeight > object.y;
        }
        drawUI() {
            this.gameUI.draw(ctx, this.player.ability);
        }
    }
    const game = new Game();
    // game.pickups.push(new Shield());
    // game.pickups.push(new Turret());
    let lastTime = 0;
    function animate(timeStamp) {
        const deltaTime = timeStamp - lastTime;
        lastTime = timeStamp;
        game.draw(deltaTime);
        game.update(deltaTime);
        if (game.gameOver) (0, $f7b1c61d75fa3a2d$export$2e2bcd8739ae039)(game.score);
        if (!game.gameOver) requestAnimationFrame(animate);
    }
    function startGameUI() {
        const startBtn = document.getElementById("start");
        const restartBtn = document.getElementById("restart");
        startBtn.addEventListener("click", ()=>{
            startBtn.hidden = true;
            animate(0);
        });
        restartBtn.addEventListener("click", ()=>{
            game.gameOver = false;
            restartBtn.hidden = true;
            const gameOverUI = document.getElementById("gameOver");
            gameOverUI.hidden = true;
            animate(0);
        });
    }
});


//# sourceMappingURL=index.fa8d88ce.js.map
